import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { ApolloError } from '@apollo/client'
import { ErrorResponse } from '@apollo/client/link/error'

const i18nDefault = {
  errors: {
    notAllow: '你不是創作者或你不是此篇文章的創作者唷！',
    publish: {
      forbidden: 'Hello, 你沒有創作者的權限唷，請幫忙確認登入的帳號 \uD83D\uDE00',
      missing: 'Hello，我們系統發生錯誤了，無法發佈你的文章 \uD83D\uDE00',
      missing_field: 'Hello，我們系統有發生錯誤，無法發佈你的文章 \uD83D\uDE00',
      unauthorized: 'Hello，我們系統有錯誤，無法發佈你的文章 \uD83D\uDE00',
      db_operation_fail: 'Hello，我們系統有錯誤出現了，無法發佈你的文章 \uD83D\uDE00',
      gcs_operation_fail: 'Hello，我們系統發生錯誤，無法發佈你的文章 \uD83D\uDE00',
      image_processing_fail: 'Hello，我們系統發生錯誤了，無法發佈你的文章 \uD83D\uDE00',
      unexpected: 'Hello，我們系統有錯誤出現，無法發佈你的文章 \uD83D\uDE00',
    },
  },
}

export function handleGraphqlError(error: ApolloError | ErrorResponse) {
  if (error.graphQLErrors) {
    for (const graphError of error.graphQLErrors) {
      if (['forbidden', 'unauthorized'].includes(graphError.extensions.code)) {
        return { message: i18nDefault.errors.notAllow, shouldRedirect: true }
      }
      const code = graphError.extensions.code
      return { message: code, code }
    }
  }
  return { message: (error as ApolloError).message }
}

export const useGraphQLErrorsHandler = () => {
  const { t } = useTranslation(['editor'])
  return useCallback(
    (error: ApolloError | ErrorResponse) => {
      const { code, message, shouldRedirect } = handleGraphqlError(error)

      if (shouldRedirect) {
        window.alert(t(['errors.notAllow', message]))
        window.location.href = '/'
        return
      }

      if (code) {
        window.alert(t([`errors.publish.${code}`, i18nDefault.errors.publish[code]]))
        return
      }

      throw new Error(message ?? '!')
    },
    [t],
  )
}
